import "../Css/Hobbies.css";
import React from "react";

const hobbies = [
    { icon: <i className="fa-solid fa-person-running"></i>, label: 'Workout' },
    { icon: <i className="fa-solid fa-person-hiking"></i>, label: 'Hiking' },
    { icon: <i className="fa-solid fa-book-open"></i>, label: 'Reading' },
];
const Hobbies = () => {

    return (

        <section className="mb-3" id="hobbies">

            <h2 className="section-title">
                <i className="fas fa-heart"></i> <span style={{ marginLeft: "10px" }}>Hobbies</span>
            </h2>

            <div className="hobbies-list">
                {
                    hobbies.map((hobby, index) => (

                        <span key={index} className="hobby-item">
                            <span className="hobby-icon">{hobby.icon}</span>
                            {hobby.label}
                        </span>

                    ))
                }
            </div>

        </section>

    );

};

export default Hobbies;